import { render, staticRenderFns } from "./ProductSlideshow.vue?vue&type=template&id=bb1671e6&"
import script from "./ProductSlideshow.vue?vue&type=script&lang=js&"
export * from "./ProductSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./ProductSlideshow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports